export const API_ENDPOINTS = {
  posts:'posts'
};

export const API_ENVIRONMENT = {
  "company-info": "local",
};
